module.exports = __webpack_public_path__ + "img/ic_home_walking_white.aa00bf42.svg";